import React, { useState } from "react";
import CalendarView from "../components/CalendarView";
import ResourceSnapper from "../components/ResourceSnapper";

const CalendarPage = ({ courseId, onOpenLesson }) => {
  const [selectedLesson, setSelectedLesson] = useState(null);

  const handleDateSelect = (event) => {
    if (!event?.lesson_id) return;
    setSelectedLesson(event.lesson_id);
    onOpenLesson?.(event.lesson_id);
  };

  if (!courseId) {
    return (
      <div className="empty-state">
        <p>Select a course to begin planning</p>
      </div>
    );
  }

  return (
    <>
      <div data-tour="calendar-grid">
        <CalendarView courseId={courseId} onDateSelect={handleDateSelect} />
      </div>

      <div className="resource-section" data-tour="calendar-resource-snap">
        <ResourceSnapper lessonId={selectedLesson} teksId={null} onSuccess={() => {}} />
      </div>
    </>
  );
};

export default CalendarPage;
